/* eslint-disable react/no-children-prop */
import { themeStore } from "@/stores/theme";
import { useTranslate } from "@/utils/lang";
import { AlbumWords } from "@/utils/lang/album";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Flex,
  Button,
  useBoolean,
  Radio,
  RadioGroup,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useCallback, useState } from "react";
import { albumStore } from "../store";
import { OpModalBaseProps } from "../type";

type Props = OpModalBaseProps & {
  albumId: number;
  isDeleteImage?: boolean;
};

type OpData = { type: "delete"; data: { id: number; type: 1 | 2 } };

function DeleteModal(props: Props) {
  const { panelBg } = themeStore.styles;
  const { isOpen, onClose, albumId, store = albumStore } = props;
  const [loading, setLoading] = useBoolean(false);
  const [opData, setOpData] = useState<OpData>({ type: "delete", data: { id: albumId, type: 1 } });

  const { translate } = useTranslate();

  const content = {
    type: "delete",
    title: translate(AlbumWords.deleteAlbumModalTitle),
    cancelBtn: translate(AlbumWords.cancel),
    confirmBtn: translate(AlbumWords.confirmDelete),
    loading: translate(AlbumWords.deleting),
    option1: translate(AlbumWords.deleteAlbumModalOption1),
    option2: translate(AlbumWords.deleteAlbumModalOption2),
  };

  const onSecondConfirm = () => {
    if (!opData || !opData.data) return;
    setLoading.on();
    store.deleteAlbum(opData.data).then(onClose).finally(setLoading.off);
  };

  const handleDeleteTypeChange = useCallback(
    (type: string) => {
      setOpData({ type: "delete", data: { id: albumId, type: Number(type) as 1 | 2 } });
    },
    [setOpData],
  );
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent bg={panelBg} w="716px" mt="278px">
        <ModalHeader color="white" textAlign="center" pt="40px" fontSize="32px">
          {content.title}
        </ModalHeader>
        <ModalCloseButton color="white" />
        <ModalBody px="88px">
          <RadioGroup defaultValue="1" onChange={handleDeleteTypeChange}>
            <Flex flexDir="column" color="#dcdcdc">
              <Radio value="1">{content.option1}</Radio>
              <Radio value="2">{content.option2}</Radio>
            </Flex>
          </RadioGroup>
          <Flex justify="center" mt="58px" mb="48px">
            <Button variant="dark.solid" w="140px" mr="14px" onClick={onClose}>
              {content.cancelBtn}
            </Button>
            <Button
              variant="primary"
              w="140px"
              bg="#ff5050"
              borderColor="#ff5050"
              _hover={{
                bg: "#ff5050",
              }}
              isLoading={loading}
              disabled={loading}
              loadingText={content.loading}
              onClick={onSecondConfirm}
            >
              {content.confirmBtn}
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default observer(DeleteModal);
